// extracted by mini-css-extract-plugin
export default {"titleContainer":"PageTitle_titleContainer__tTA9J","pageTitle":"PageTitle_pageTitle__ASBUq","actions":"PageTitle_actions__JQXTK"};